import { defineComponent as _defineComponent } from 'vue'
import changeProfile from '@/components/settings-components/profile.vue'
import qrOverlay from '@/components/settings-components/qr-overlay.vue'
import calendarOverlay from '@/components/settings-components/calendar-overlay.vue'
import rateOverlay from '@/components/settings-components/rate-overlay.vue'
import availabilityOverlay from '@/components/settings-components/availability-overlay.vue'
import VersionLabel from '@/components/version.vue'

import { useRouter } from 'vue-router';
import {onBeforeMount, onMounted, ref, computed} from 'vue'
import { } from '@busy-human/opt-library';
import { useUserspace } from '@/store/userspace'


enum stages{
    SETTINGS = 0,
    PROFILEICON = 1,
    QR = 2,
    CALENDAR = 3,
    AVAILABILITY = 4,
    STANDARD = 5,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'settings',
  setup(__props, { expose }) {
  expose();

const stage = ref(stages.SETTINGS)

const noScroll = ref(false)

const router = useRouter();

const goTo = (route: string) => {
    router.push(route)
}

const userspace = useUserspace();
const user = computed(() => userspace.user);


let userInitials = ref(((user.value?.name?.firstName?.[0] || '')+' '+(user.value?.name?.lastName?.[0] || '')).toUpperCase())


const __returned__ = { stages, stage, noScroll, router, goTo, userspace, user, userInitials, changeProfile, qrOverlay, calendarOverlay, rateOverlay, availabilityOverlay, VersionLabel, useRouter, onBeforeMount, onMounted, ref, computed, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})